export default "__VITE_ASSET__CK_cwlAR__"